var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinSdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102.342mm",
    height: "102.34108mm",
    viewBox: "0 0 102.342 102.34108",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient11"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffe6e7",
      stopOpacity: 0.58007812
    },
    offset: 0,
    id: "stop12"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffe680",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop11"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient11",
    id: "linearGradient12",
    x1: 126.62581,
    y1: 102.12332,
    x2: 83.374214,
    y2: 194.87665,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    gradientTransform: "translate(-53.828987,-97.32946)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 1,
      fill: "url(#linearGradient12)",
      stroke: "#d4aa00",
      strokeWidth: 6,
      strokeLinejoin: "round",
      strokeDasharray: "none"
    },
    id: "path11",
    cx: 51.171005,
    cy: 51.17054,
    rx: 48.171001,
    ry: 48.17054
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-53.828987,-97.32946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9289",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 22.926,
    strokeWidth: 2.5744,
    d: "m 125.73697,141.78129 c 0.75671,0.19051 1.83093,0.77524 2.43418,1.1377 1.34726,0.91574 1.16946,0.85461 2.01611,1.52136 1.38695,1.28429 2.22251,2.32569 2.95805,3.98463 2.99508,6.74157 -1.78858,14.46741 -10.19968,15.79299 -2.14577,0.33865 -5.06413,0.18785 -7.31573,0.18785 H 93.211751 c -5.44248,-1e-5 -8.800046,0.49742 -12.718523,-2.02143 -2.452687,-1.57955 -5.024445,-4.91859 -4.439708,-9.10166 0.515937,-3.69623 3.230558,-6.4717 6.122458,-7.68879 0.153455,-2.11666 0.33866,-3.56128 1.336141,-5.28637 0.912822,-1.56899 1.881194,-2.6432 3.148552,-3.70153 0.997442,-0.83082 2.926286,-1.85472 4.669889,-2.37596 3.230559,-0.96572 5.411527,-0.74506 6.368521,-0.54767 9.051399,-10.44312 27.868569,-5.08267 28.037889,8.09888 z",
    style: {
      display: "inline",
      stroke: "#aa8800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9291",
    fill: "#ffffff",
    d: "m 120.13046,143.76831 c -2.15106,-0.0106 -4.30212,-0.0212 -5.48482,-0.0132 -1.18268,0.0106 -1.39435,0.0397 -1.57161,0.0794 -0.17464,0.0423 -0.3096,0.0952 -0.44716,0.18519 -0.14049,0.0869 -0.27776,0.21175 -2.96862,2.91835 -2.69082,2.70934 -7.92957,8.00366 -10.747395,10.75531 -2.820451,2.75432 -3.217336,2.96863 -3.550696,3.17235 -0.333252,0.20395 -0.608508,0.39694 -0.923402,0.58475 -0.317316,0.18551 -0.674663,0.3678 -1.042443,0.55035 -0.365088,0.18261 -0.735569,0.3651 -1.206502,0.53448 -0.470937,0.17201 -1.042462,0.33336 -1.51341,0.43919 -0.470969,0.10848 -0.84139,0.16141 -1.238255,0.20903 -0.396877,0.0503 -0.820216,0.0926 -1.02394,0.10848 -0.203736,0.0159 -0.193116,0.005 4.19365,-1e-5 4.386791,-0.005 13.144503,-0.003 17.523353,-0.003 l 4.3815,0.003 c 0.003,7.3e-4 0.005,5.9e-4 0.92604,-3.22792 0.92074,-3.22791 2.75961,-9.68111 3.69623,-12.93547 0.93398,-3.25439 0.96573,-3.30731 0.99749,-3.36022 z",
    style: {
      display: "inline",
      fill: "#aa8800",
      stroke: "#aa8800",
      strokeWidth: 0.264583
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinSdt);
export default __webpack_public_path__ + "static/media/coin-sdt.d9a154de923ace51957b349981a90e5f.svg";
export { ForwardRef as ReactComponent };